// extracted by mini-css-extract-plugin
module.exports = {"newMessageUnRead":"NewMessageTips_newMessageUnRead__xY8S5","icon":"NewMessageTips_icon__O3x0t"};